var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',[_c('cabecalho',{attrs:{"title":"CONTABIL_FECHAMENTO.PAGE_TITLE","linkRetornar":"contabil"}}),_c('filtro-contabil',{on:{"obter-resultado":_vm.obterResultado}}),_c('tabela-contabil',{attrs:{"items":_vm.items},on:{"alterar-ordenacao":_vm.novaOrdenacao}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }